import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { PropertyType } from "./PropertyType";
import { PropertyEntity } from "./PropertyEntity";
/**
 * Property class
 */

export class Property extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getTypeId = () => {
      return this.model.typeId;
    };

    this.getValue = () => {
      return this.model.value;
    };

    this.getAlias = () => {
      return this.model.alias;
    };

    this.getSort = () => {
      return this.model.sort;
    };

    this.getCurrent = () => {
      return this.model.current;
    };

    this.getPropertyType = type => {
      return this.getRelation('type', PropertyType, type);
    };

    this.getPropertyEntity = entities => {
      return this.getRelation('entities', PropertyEntity, entities);
    };
  }

  /**
   * Create property
   *
   * @param {object} object
   *
   * @return {Property}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list properties
   *
   * @param {object} objects
   *
   * @return {Array.<Property>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map properties
   *
   * @param {Array.<object>} objects
   * @param {function(Property): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get property id
   *
   * @return {number}
   */


}